import React from 'react';
import { ExtraStyleType, FieldCustom } from '../FieldCustom/FieldCustom';

export default function TextareaFieldCustom({
  disabled,
  extraStyle,
  label,
  name,
  required,
  rows,
}: {
  disabled?: boolean;
  extraStyle?: ExtraStyleType;
  label: string;
  name: string;
  required?: boolean;
  rows: number;
  uppercase?: boolean;
}): JSX.Element {
  return (
    <>
      <FieldCustom
        as="textarea"
        disabled={disabled}
        extraStyle={extraStyle}
        label={label}
        name={name}
        required={required}
        type="textarea"
        rows={rows}
      />
    </>
  );
}
